import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import customConfirmationWildfires from "../../../../src/content/wildfires/customConfirmationDonation";
import styles from "../../../../src/content/wildfires/wildfires.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  customConfirmationWildfires,
  styles,
  React
};